// extracted by mini-css-extract-plugin
export var localeSelector = "_45-0";